import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.base_url = 'http://jpbs.com/api/adminaioaojxxl'
Vue.prototype.base_url = 'https://api.japanbus.cn/api/adminaioaojxxl'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')